<form [formGroup]="specVerliescompensatieFormGroup">
    <div formGroupName="specificatieVerliescompensatie">
        <div formGroupName="opbouw">
            <div
                    *ngIf="specVerliescompensatie.specificatieVerliescompensatie?.opbouw?.verrekendVerliesBox1 !== undefined">
                <div class="row">
                    <div class="col col-1">
                        <p>Af: Verrekend verlies</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control formControlName="verrekendVerliesBox1"
                                                          id="verrekendVerliesBox1"
                                                          class="custom-input-150"
                                                          [decimals]="0"
                                                          prefix="€ -"
                                                          align="right"
                                                          [disabledControl]="true">
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
    </div>
</form>
